export const environment = {
  production: true,
  kakaoWebKey: '5352f9c75722140c325e10e873265f00',
  domainName: 'types.my',
  webUrl: 'https://types.my',
  cabinetWebUrl: 'https://askme.cab',
  apiUrl: 'https://api-types.headmost.app/api',
  googleAnalyticsMeasurementId: 'G-ZMWXXP2VYX',
  amplitudeKey: '245e7ac3d96f46d0c3efef17214fdbf0',
  measuredApiKey: 'e6f899c4-455d-4ae8-afba-e1cc73cf2673',
  externalLink: {
    base: 'https://types.oopy.io',
    faq: 'https://types.oopy.io/faq',
    suggest: 'https://bit.ly/3luE9kC',
  },
  imageCDNUrl: 'https://d2dwq87srzo293.cloudfront.net',
  giphyApiKey: 'voAw2KTpQcX9WLygIYh3N1GNATPqYx1r',
  photoroomApiKey: '97fc1770307cbe90607de1cf1191935ecedcd50a',
}

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
